<!-- <nz-date-picker [nzDisabledDate]="disabledStartDate" nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss" [(ngModel)]="startValue"
  nzPlaceHolder="Inizio" (nzOnOpenChange)="handleStartOpenChange($event)"></nz-date-picker>
<nz-date-picker #endDatePicker [nzDisabledDate]="disabledEndDate" nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss"
  [(ngModel)]="endValue" nzPlaceHolder="Fine" (nzOnOpenChange)="handleEndOpenChange($event)"></nz-date-picker> -->
@if (props.label) {
  <label class="date-picker-label">{{ props.label }}</label>
}
<nz-range-picker [formControl]="formControl" [formlyAttributes]="field" [nzShowTime]="false" [nzFormat]="'dd/MM/yyyy'"></nz-range-picker>
